// extracted by mini-css-extract-plugin
export var createdDate = "_ke-1";
export var divider = "_ke-2";
export var headerDivider = "_ke-3";
export var messagesCard = "_ke-0";
export var messagesContainer = "_ke-7";
export var messagesContainerWrapper = "_ke-4";
export var pointerCapturingButtonBoxes = "_ke-a";
export var showLeftPanelButton = "_ke-9";
export var showMoreButton = "_ke-c";
export var showMoreButtonContainer = "_ke-b";
export var summaryTitle = "_ke-6";
export var systemMessageCardWrapper = "_ke-d";
export var topButtons = "_ke-8";
export var withPadding = "_ke-5";